import actionTypes from './constants';

/* */
const initialState = {
  exercises: [],
  membership: null,
  due: {
    memberships: [],
  },
  memberCardOpened: false,
};

/* */
export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.OPEN_MEMBER_CARD:
      return { ...state, memberCardOpened: true };
    case actionTypes.CLOSE_MEMBER_CARD:
      return { ...state, memberCardOpened: false };
    case actionTypes.SET_MEMBERSHIP:
      return {
        ...state,
        membership: action.payload,
      };
    case actionTypes.SET_EXERCISES_LIST:
      return {
        ...state,
        exercises: action.payload,
      };
    case actionTypes.UPDATE_DUE:
      return {
        ...state,
        due: {
          ...state.due,
          ...action.payload,
        },
      };
    default:
      return state;
  }
};
